exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".box-data{border:1px solid #ede8e4;padding:20px;margin-bottom:20px}.box-data:last-child{margin-bottom:0}span.disabled{background:none;border:none;cursor:default;font-weight:700;font-size:18px;padding:5px 0 0;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f2c6750","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/my-data/my-medical-data.vue
// module id = 892
// module chunks = 0